module.exports = __webpack_public_path__ + "img/dstv-change-package-1.6bf2f8c3.jpg";